export const cities: string[] = [
  'Adana', 'Adapazarı', 'Afyonkarahisar', 'Ankara', 'Antalya', 'Aydın',
  'Balıkesir', 'Bursa', 'Çorum', 'Denizli', 'Diyarbakır', 'Elazığ',
  'Erzurum', 'Gaziantep', 'Hatay', 'İstanbul', 'İzmir', 'Kahramanmaraş',
  'Kayseri', 'Kocaeli', 'Konya', 'Kütahya', 'Malatya', 'Manisa',
  'Mersin', 'Muğla', 'Ordu', 'Osmaniye', 'Samsun', 'Sivas',
  'Şanlıurfa', 'Tarsus', 'Tekirdağ', 'Trabzon', 'Van',
];
